import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { LOCALES, DEFAULT_LOCALE, getLocale, stripLocale, localePath, OG_LOCALE, HTML_LANG } from '../i18n'

export const SITE = 'https://vorba.dev'
const DEFAULT_OG = `${SITE}/og-image.png`

// Sursă UNICĂ pentru tot meta-ul per-pagină (title/description/canonical/robots/OG/Twitter)
// + hreflang pe cele 3 limbi + <html lang> + JSON-LD opțional. index.html nu mai conține
// aceste tag-uri → zero duplicate în HTML-ul prerendat. La prerender helmet a updatat deja
// <head>, deci fiecare rută×limbă are meta corect, baked în HTML pentru crawlere (AI, social).
export default function Seo({ title, description, image = DEFAULT_OG, type = 'website', schema, noindex = false }) {
  const { pathname } = useLocation()
  const locale = getLocale(pathname)
  const logical = stripLocale(pathname)
  const url = SITE + (pathname === '/' ? '/' : pathname)

  return (
    <Helmet htmlAttributes={{ lang: HTML_LANG[locale] }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />

      {/* hreflang — leagă variantele de limbă (x-default = en) */}
      {LOCALES.map((loc) => (
        <link key={loc} rel="alternate" hrefLang={loc} href={SITE + localePath(loc, logical)} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={SITE + localePath(DEFAULT_LOCALE, logical)} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="vorba.dev" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1731" />
      <meta property="og:image:height" content="909" />
      <meta property="og:image:alt" content="vorba.dev — custom software, integrations and AI for mid-market companies" />
      <meta property="og:locale" content={OG_LOCALE[locale]} />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema ? <script type="application/ld+json">{JSON.stringify(schema)}</script> : null}
    </Helmet>
  )
}
